import { getStopApi } from '../../../../../../services/StopApi/StopApi';

export const getTransportList = async ({
  commonParams,
  authorization,
  getFundingSTOPBilltoOrganizationName,
  getDepartingSAPorJailDepartureLocationName,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        trnID: item.trnID,
        fundingSTOPBilltoOrganizationName: getFundingSTOPBilltoOrganizationName(
          item.fundingSTOPBilltoOrganization
        ),
        departingSAPorJailDepartureLocationName:
          getDepartingSAPorJailDepartureLocationName(
            item.departingSAPorJailDepartureLocation
          ),
      })),
    };
  }).catch((e) => alert(e));
};
